import BucketDeals from "../../features/bucket-deals/BucketDeals";
import Home from "../../features/home/Home";

export default function LandingPage() {
  return (
    <div>
      <Home />
    </div>
  );
}
